import React, { useState, useEffect } from 'react';
import { Grid, styled, Typography, Card, Button, Autocomplete, TextField, Stack, Checkbox, FormControlLabel } from '@mui/material';
import {
  getAnalyticsViewsLink,
  getAnalyticsViewsCompanies,
  getAnalyticsViewsEmployees,
  getAnalyticsViewsProducts,
} from '_services/ApiService';

const Root = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(4)
}));

const PageTitle = ({ children }) => (
  <Typography variant="h1">{children}</Typography>
);

const SectionTitle = ({ children }) => (
  <Typography variant="h2">{children}</Typography>
);

const products = [
  {id: 'compensation-benchmarking', label: 'Compensation Benchmarking' },
  {id: 'wurkforce-analytics', label: 'Wurkforce Analytics' },
  {id: 'wurkforce-analytics-myteam', label: 'Wurkforce Analytics My Team' },
  {id: 'org-chart', label: 'Org Charts' },
]

const ProductSelector = ({value, onChange}) => {
  const [products, setProducts] = useState([]);

  async function loadProducts() {
    setProducts([])
    const newProducts = await getAnalyticsViewsProducts();
    setProducts(newProducts.map(p => ({...p, label: p.name})))
  }

  useEffect(() => {
    loadProducts()
  }, [])

  if(products.length === 0) {
    return <>Loading...</>
  }
  return (
    <Autocomplete
      value={value}
      options={products}
      renderInput={(params) => <TextField {...params} label="Product" />}
      onChange={(e, v) => onChange(v)}
    />
  )
}

const LoginSelector = ({company, value, onChange}) => {
  const [logins, setLogins] = useState([]);

  async function loadLogins() {
    setLogins([])
    if(!company) {
      return
    }
    const newLogins = await getAnalyticsViewsEmployees(company);
    setLogins(
      newLogins.map(l => ({id: l.username, label: `${l.username} - ${l.name}`}))
    )
  }

  useEffect(() => {
    loadLogins()
  }, [company])

  if(logins.length === 0) {
    return <>Loading...</>
  }
  return (
    <Autocomplete
      value={value}
      options={logins}
      renderInput={(params) => <TextField {...params} label="User" />}
      onChange={(e, v) => onChange(v)}
    />
  )
}


const CompanySelector = ({value, onChange}) => {
  const [companies, setCompanies] = useState([]);

  async function loadCompanies() {
    setCompanies([])
    const newCompanies = await getAnalyticsViewsCompanies()
    setCompanies(newCompanies.map(c => ({label: c, id: c})))
  }

  useEffect(() => {
    loadCompanies()
  }, [])

  if(companies.length === 0) {
    return <>Loading...</>
  }
  return (
    <Autocomplete
      value={value}
      options={companies}
      renderInput={(params) => <TextField {...params} label="Company" />}
      onChange={(e, v) => onChange(v)}
    />
  )
}

const Link = ({product, company, login, ignoreChecks}) => {
  console.log({product, company, login, ignoreChecks})

  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);
  async function loadUrl() {
    if(!product || !company || !login) {
      setUrl(null);
      setError(null);
      return;
    }
    try {
      const link = await getAnalyticsViewsLink(product, company, login, ignoreChecks)
      setUrl(link.url);
      setError(null);
    } catch(e) {
      setUrl(null);
      setError(e.message)
    }
  }

  useEffect(() => {
    setUrl(null);
    loadUrl();
  }, [product, company, login]);

  useEffect(() => {
    // Auto-refresh URL every minute, it expires after 2 minutes
    if(product && company && login) {
      const intervalId = setInterval(() => loadUrl(), 60000)
      return () => clearInterval(intervalId)
    }
  }, [product, company, login]);

  return <>
    {url &&
      <Button
        href={url}
        target='_blank'
        variant='contained'
        color='secondary'
        style={{margin: '5px'}}
      >
        Open {product}
      </Button>
    }
    {error}
  </>
}

const AnalyticsViews = () => {
  const [product, setProduct] = useState(products.find(p => p.id == 'compensation-benchmarking'));
  const [company, setCompany] = useState(null);
  const [login, setLogin] = useState(null);
  const [ignoreChecks, setIgnoreChecks] = useState(false);

  useEffect(() => {
    setLogin(null)
  }, [company]);

  return <>
    <Root container spacing={2}>
      <Grid item xs={6}>
        <PageTitle>Analytics Views</PageTitle>
        <Card style={{padding: '10px', minHeight: '150px'}}>
          <Stack spacing={2} sx={{ width: "100%" }}>
            <SectionTitle>Impersonator</SectionTitle>
            <ProductSelector value={product} onChange={setProduct} />
            <CompanySelector value={company} onChange={setCompany} />
            {company && <LoginSelector company={company.id} value={login} onChange={setLogin} />}
            <FormControlLabel control={<Checkbox checked={ignoreChecks} onChange={(evt) => setIgnoreChecks(evt.target.checked)} />} label="Bypass product/security checks" />
            <div>
              <Link key={`${product.id}-${company?.id}-${login?.id}-${ignoreChecks}`} product={product.id} company={company?.id} login={login?.id} ignoreChecks={ignoreChecks} />
            </div>
          </Stack>
        </Card>
      </Grid>
    </Root>
  </> 
};

export default AnalyticsViews;
